<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card>
            <div slot="header"><i class='fa fa-align-justify'></i> 审核标签</div>
            <v-server-table ref="table" :url="backendUrl + '/label/review/get'" :columns="columns" :options="options" @error="errorLoadingTableData">
              <b-button-group slot="status" slot-scope="props" v-if="hasReviewRole && props.row.status === '待审核'">
                <b-button variant="success" @click="clickReview(props.row.id, '通过')"><i class='fa fa-check'></i></b-button>
                <b-button variant="danger" @click="clickReview(props.row.id, '不通过')"><i class='fa fa-ban'></i></b-button>
              </b-button-group>
              <span slot="status" v-else>{{ props.row.status }}</span>
              <a v-if="props.row.version" slot="version" slot-scope="props" :href="backendUrl + '/zip/' + props.row.version + '.zip'">{{ props.row.version }}</a>
              <b-button v-if="props.row.event == '新增' || props.row.event == '编辑'" slot="directionCode" slot-scope="props" variant="primary" @click="clickDirectionCode(props.row.id)"><i class="fa fa-eye"></i></b-button>
              <c-switch v-if="props.row.event == '新增' || props.row.event == '编辑'" slot="fromAgent" slot-scope="props" v-model="props.row.fromAgent" size="lg" color="primary" variant="pill" label v-bind="labelTxt" disabled />
              <b-button v-if="props.row.xmlFile" slot="xmlFile" slot-scope="props" variant="primary" @click="clickXmlFile(props.row.id)"><i class="fa fa-eye"></i></b-button>
              <b-button v-if="props.row.jasperFile" slot="jasperFile" slot-scope="props" variant="primary" v-bind:href="backendUrl + '/label/review/getJasperFile/' + props.row.id + '?username=' + username" target='_blank'><i class="fa fa-eye"></i></b-button>
            </v-server-table>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal title="流向代码" size="sm" v-model="directionCodeModal" @ok="directionCodeModal = false" modal-class="modal-primary" ok-only>
      <div class="d-block text-center">
        <b-form-textarea v-model="directionCode" :rows="9"></b-form-textarea>
      </div>
    </b-modal>
    <b-modal title="源码" size="lg" v-model="xmlFileModal" @ok="xmlFileModal = false" modal-class="modal-primary" ok-only>
      <div class="d-block text-center">
        <b-form-textarea v-model="xmlFile" :rows="9"></b-form-textarea>
      </div>
    </b-modal>
    <b-modal :title="errorTitle" class="modal-danger" v-model="errorModal" @ok="errorModal = false" modal-class="modal-danger" ok-variant="danger" ok-only>
      <p>{{ errorMessage }}</p>
    </b-modal>
  </div>

</template>

<script>
import axios from 'axios'
import { Switch as cSwitch } from '@coreui/vue'

export default {
  components: {
    cSwitch
  },
  data () {
    return {
      username: '', // 用户名,
      hasReviewRole: this.$root.userInfo.userType === 0 || this.$root.userInfo.permissions.includes('L002'), // 审核标签
      directionCodeModal: false,
      xmlFileModal: false,
      errorModal: false,
      backendUrl: axios.backendUrl,
      columns: ['status', 'event', 'version', 'labelId', 'name', 'printSize', 'labelType', 'directionCode', 'fromAgent', 'xmlFile', 'jasperFile', 'createBy', 'createTime', 'reviewBy', 'reviewTime'],
      options: {
        filterable: false,
        perPage: 10,
        perPageValues: [10],
        headings: {
          status: '审核状态',
          event: '操作',
          version: '压缩包',
          labelId: '编号',
          name: '名称',
          labelType: '类型',
          directionCode: '流向',
          fromAgent: '请求代理接口',
          printSize: '尺寸',
          xmlFile: '源码',
          jasperFile: '预览',
          createBy: '创建人',
          createTime: '创建时间',
          reviewBy: '审核人',
          reviewTime: '审核时间'
        }
      },
      directionCode: null,
      xmlFile: null,
      errorTitle: null,
      errorMessage: null,
      labelTxt: {
        dataOn: '是',
        dataOff: '否'
      }
    }
  },
  methods: {
    showError(error) {
      if (error.response) {
        this.errorTitle = error.response.data.error
        this.errorMessage = error.response.data.message
        this.errorModal = true
      } else {
        this.errorTitle = error.message
        this.errorMessage = '无法访问后端'
        this.errorModal = true
      }
    },
    errorLoadingTableData(error) {
      this.showError(error)
    },
    clickDirectionCode(id) {
      axios.get(this.backendUrl + '/label/review/getDirectionCode/' + id).then(response => {
        this.directionCode = response.data
        this.directionCodeModal = true
      }).catch(error => {
        this.showError(error)
      })
    },
    clickXmlFile(id) {
      axios.get(this.backendUrl + '/label/review/getXmlFile/' + id).then(response => {
        this.xmlFile = response.data
        this.xmlFileModal = true
      }).catch(error => {
        this.showError(error)
      })
    },
    clickJasperFile(id) {
      axios.get(this.backendUrl + '/label/review/getJasperFile/' + id, {responseType: 'blob'}).then(response => {
        var a = document.createElement('a')
        a.href = window.URL.createObjectURL(response.data)
        a.target = '_blank'
        a.click()
        a.remove()
      }).catch(error => {
        this.showError(error)
      })
    },
    clickReview(id, status) {
      var querystring = require('querystring')
      axios.post(this.backendUrl + '/label/review/review/' + id + '/' + status).then(response => {
        this.$refs.table.refresh()
      }).catch(error => {
        this.showError(error)
      })
    }
  }
}
</script>

<style>
  th, td:nth-child(odd), td:nth-child(even) {
    vertical-align: middle;
    white-space: nowrap;
    text-align: center;
  }
</style>
